import { __assign } from "tslib";
import * as React from 'react';
import { StyledIconBase } from '@styled-icons/styled-icon';
export var MapOutline = React.forwardRef(function (props, ref) {
  var attrs = {
    "fill": "currentColor",
    "xmlns": "http://www.w3.org/2000/svg"
  };
  return React.createElement(StyledIconBase, __assign({
    iconAttrs: attrs,
    iconVerticalAlign: "middle",
    iconViewBox: "0 0 24 24"
  }, props, {
    ref: ref
  }), React.createElement("g", {
    "data-name": "Layer 2",
    key: "k0"
  }, React.createElement("path", {
    d: "M20.41 5.89l-4-1.8h-.82L12 5.7 8.41 4.09h-.05L8.24 4h-.6l-4 1.8a1 1 0 00-.64 1V19a1 1 0 00.46.84A1 1 0 004 20a1 1 0 00.41-.09L8 18.3l3.59 1.61h.05a.85.85 0 00.72 0h.05L16 18.3l3.59 1.61A1 1 0 0020 20a1 1 0 00.54-.16A1 1 0 0021 19V6.8a1 1 0 00-.59-.91zM5 7.44l2-.89v10l-2 .89zm4-.89l2 .89v10l-2-.89zm4 .89l2-.89v10l-2 .89zm6 10l-2-.89v-10l2 .89z",
    "data-name": "map"
  })));
});
MapOutline.displayName = 'MapOutline';
export var MapOutlineDimensions = {
  height: 20,
  width: 20
};